/**
 * Lê os campos de entrada direto do formulário, na hora de enviar.
 *
 * Por quê: o navegador preenche e-mail e senha guardados sem avisar a tela
 * (o Chrome só entrega a senha depois de um clique). Uma tela que guarda os
 * campos a cada tecla e desliga o botão enquanto eles estão "vazios" fica com
 * o botão apagado mesmo com tudo preenchido. Lendo o formulário no envio, vale
 * o que está escrito na tela, digitado ou preenchido pelo navegador.
 */
export function readFields<K extends string>(
  form: HTMLFormElement | FormData,
  names: readonly K[],
): Record<K, string> | null {
  const data = form instanceof FormData ? form : new FormData(form);
  const values = {} as Record<K, string>;
  for (const name of names) {
    const raw = data.get(name);
    const value = typeof raw === 'string' ? raw : '';
    // E-mail sem espaços nas pontas; a senha vai como foi escrita.
    values[name] = name === 'email' ? value.trim() : value;
    if (!values[name]) return null;
  }
  return values;
}
